import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
// import '/lib/bootstrap4/bootstrap.bundle';
// import '/lib/bootstrap4/bootstrap';


$(document).foundation();




var backtotop = {
    init: function() {

        // Back to Top - by CodyHouse.co
        var backTop = document.getElementsByClassName('js-cd-top')[0],
            // browser window scroll (in pixels) after which the "back to top" link is shown
            offset = 300,
            //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
            offsetOpacity = 1200,
            scrollDuration = 700,
            scrolling = false;
        if (backTop) {
            //update back to top visibility on scrolling
            window.addEventListener("scroll", function(event) {
                if (!scrolling) {
                    scrolling = true;
                    (!window.requestAnimationFrame)
                        ? setTimeout(checkBackToTop, 250)
                        : window.requestAnimationFrame(checkBackToTop);
                }
            });
            //smooth scroll to top
            backTop.addEventListener('click', function(event) {
                event.preventDefault();
                (!window.requestAnimationFrame)
                    ? window.scrollTo(0, 0)
                    : scrollTop(scrollDuration);
            });
        }

        function scrollTop(duration) {
            var start = window.scrollY || document.documentElement.scrollTop,
                currentTime = null;

            var animateScroll = function(timestamp) {
                if (!currentTime)
                    currentTime = timestamp;
                var progress = timestamp - currentTime;
                var val = Math.max(Math.easeInOutQuad(progress, start, -start, duration), 0);
                window.scrollTo(0, val);
                if (progress < duration) {
                    window.requestAnimationFrame(animateScroll);
                }
            };

            window.requestAnimationFrame(animateScroll);
        }

        Math.easeInOutQuad = function(t, b, c, d) {
            t /= d / 2;
            if (t < 1)
                return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        };

    }
}

$(document).ready(function() {
    backtotop.init();
});

$('#dropdownMenu1').on('click', function(){
  $('#navbarNavDropdown_menu').removeClass('show');
  $('#navbarNavDropdown_lang').removeClass('show');
});
$('#dropdownMenu2').on('click', function(){
  $('#navbarNavDropdown_menu').removeClass('show');
  $('#navbarNavDropdown_search').removeClass('show');
});
$('#dropdownMenu3').on('click', function(){
  $('#navbarNavDropdown_search').removeClass('show');
  $('#navbarNavDropdown_lang').removeClass('show');
});


$(document).ready(function() { // use jQuery code inside this to avoid "$ is not defined" error
	$('.back-top-mobile').click(function(){
		document.body.scrollTop = 0;
	  document.documentElement.scrollTop = 0;
	});
});


// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    document.getElementById("back-top").style.display = "block";
  } else {
    document.getElementById("back-top").style.display = "none";
  }
}
